/**
 * round to decimal places
 * https://stackoverflow.com/questions/11832914/how-to-round-to-at-most-2-decimal-places-if-necessary
 */
const setDecimalPlaces = (num: number, decimalPlaces: number | undefined = Infinity) => {
    if(decimalPlaces === Infinity) return num;

    const coeff = 10 ** decimalPlaces;
    return Math.round(num * coeff) / coeff;
};

/**
 * Returns a random number between min and max
 */
export const getRandom = (min: number, max: number, decimalPlaces = 2): number => {
    return setDecimalPlaces(Math.random() * (max - min) + min, decimalPlaces);
};

/**
 * Returns a random integer between min and max
 */
export const getRandomInt = (min: number, max: number): number => {
    return Math.floor(Math.random() * (max - min + 1) + min);
};
